import 'bootstrap/dist/css/bootstrap.css'
import './main.css';
import { Elm } from './Main.elm';
import * as serviceWorker from './serviceWorker';
import './kit-form.js';
import './portfolioMosaic.js';

const app = Elm.Main.init({
  node: document.getElementById('root'),
  flags: null
});

// Handle structured data injection based on route
if (app.ports && app.ports.updateStructuredData) {
  app.ports.updateStructuredData.subscribe(function(data) {
    // Remove any existing structured data script
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // If data is provided, add new structured data script to head
    if (data && data.trim() !== '') {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = data;
      document.head.appendChild(script);
    }
  });
}

// Handle Open Graph URL updates based on route
if (app.ports && app.ports.updateOgUrl) {
  app.ports.updateOgUrl.subscribe(function(url) {
    // Update og:url meta tag
    let ogUrlMeta = document.querySelector('meta[property="og:url"]');
    if (ogUrlMeta) {
      ogUrlMeta.setAttribute('content', url);
    }

    // Update twitter:url meta tag
    let twitterUrlMeta = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrlMeta) {
      twitterUrlMeta.setAttribute('content', url);
    }

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', url);
    }
  });
}

// Handle Meta Description updates
if (app.ports && app.ports.updateMetaDescription) {
  app.ports.updateMetaDescription.subscribe(function(description) {
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }
    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', description);
    }
    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', description);
    }
  });
}

// Handle Title updates
if (app.ports && app.ports.updateTitle) {
  app.ports.updateTitle.subscribe(function(title) {
    document.title = title;
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    }
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', title);
    }
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


